import { Github, Linkedin, Mail } from 'lucide-react'
import { motion } from 'framer-motion'
import SectionHeader from './SectionHeader'
import { profile } from '../data/profile'

const Contact = () => {
  const handleSubmit = (event) => {
    event.preventDefault()
    alert('This is a frontend mockup. Could you please mail from services like gmail , mail or smth. Sorry for that , just testing some details :)')
  }

  return (
    <section id="contact" className="border-y border-academic-line bg-white/45 py-20 md:py-24">
      <div className="section-shell grid gap-12 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <SectionHeader
            kicker="Contact"
            title="Let’s connect."
            text="I’m open to research opportunities, graduate program conversations, and collaborative technical projects."
          />

          <div className="mt-8 grid gap-3">
            <a href={`mailto:${profile.email}`} className="card flex items-center gap-4 p-4 transition hover:border-academic-blue hover:text-academic-blue">
              <Mail size={20} /> <span>{profile.email}</span>
            </a>
            <a href={profile.github} className="card flex items-center gap-4 p-4 transition hover:border-academic-blue hover:text-academic-blue">
              <Github size={20} /> <span>NeVajnoKak</span>
            </a>
            <a href={profile.linkedin} className="card flex items-center gap-4 p-4 transition hover:border-academic-blue hover:text-academic-blue">
              <Linkedin size={20} /> <span>Yerkebulan Masssainov</span>
            </a>
          </div>
        </div>

        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55 }}
          className="card p-6 md:p-8"
        >
          <div className="grid gap-5">
            <label className="grid gap-2 text-sm font-semibold text-academic-text">
              Name
              <input
                className="rounded-2xl border border-academic-line bg-white px-4 py-3 font-normal outline-none transition focus:border-academic-blue focus:ring-4 focus:ring-academic-soft"
                type="text"
                placeholder="Your name"
                required
              />
            </label>
            <label className="grid gap-2 text-sm font-semibold text-academic-text">
              Email
              <input
                className="rounded-2xl border border-academic-line bg-white px-4 py-3 font-normal outline-none transition focus:border-academic-blue focus:ring-4 focus:ring-academic-soft"
                type="email"
                placeholder="your.email@example.com"
                required
              />
            </label>
            <label className="grid gap-2 text-sm font-semibold text-academic-text">
              Message
              <textarea
                className="min-h-36 resize-y rounded-2xl border border-academic-line bg-white px-4 py-3 font-normal outline-none transition focus:border-academic-blue focus:ring-4 focus:ring-academic-soft"
                placeholder="Write a short message..."
                required
              />
            </label>
            <button type="submit" className="primary-button w-full">
              Send Message
            </button>
          </div>
        </motion.form>
      </div>
    </section>
  )
}

export default Contact
